/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import axios from 'axios';
import axiosRetry from 'axios-retry';
import queryString from 'query-string/index';
import { NETWORK_TIMEOUT } from '../../settings';

const epoAxios = axios.create({
  paramsSerializer: {
    serialize: params => queryString.stringify(params),
  },
  withCredentials: true,
  timeout: NETWORK_TIMEOUT,
});

// Configure axios-retry
axiosRetry(epoAxios, {
  retries: 3, // Number of retry attempts
  retryDelay: (retryCount) => {
    return retryCount * 1000; // Time interval between retries in milliseconds
  },
});

export default epoAxios;
